import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useTheme } from '../contexts/ThemeContext';
import { useAuth } from '../contexts/AuthContext';
import { useResponsive } from '../contexts/ResponsiveContext';
import BackButton from '../components/BackButton';
import CompanyDirectionCard from '../components/hr/CompanyDirectionCard';

// overrideCompanyId / overrideBusinessName let an internal viewer (CRM Portal
// View) load a specific client account's company direction instead of their own.
const CompanyDirection = ({ embedded = false, overrideCompanyId = null, overrideBusinessName = '' }) => {
  const { darkMode } = useTheme();
  const { currentUser } = useAuth();
  const { isMobile } = useResponsive();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    // In override mode the business name comes from the account, not the user doc.
    if (overrideCompanyId) return;
    const loadUser = async () => {
      if (!currentUser) return;
      try {
        const userDoc = await getDoc(doc(db, 'users', currentUser.uid));
        if (userDoc.exists()) setUserData(userDoc.data());
      } catch (error) {
        console.error('Error loading user data:', error);
      }
    };
    loadUser();
  }, [currentUser, overrideCompanyId]);

  const businessName =
    overrideBusinessName ||
    userData?.businessName || userData?.companyName || userData?.company || currentUser?.displayName || '';

  return (
    <div className={embedded ? '' : `p-6 md:p-8 ${darkMode ? 'text-white' : 'text-gray-900'}`}>
      {!embedded && (
        <div className={`relative mb-6 ${isMobile ? 'pt-10' : ''}`}>
          <div className="absolute top-0 left-0">
            <BackButton />
          </div>
          <div className="text-center">
            <h1 className={`text-3xl font-bold tracking-tight text-gray-900 dark:text-white`}>Company Direction</h1>
          </div>
        </div>
      )}

      <CompanyDirectionCard businessName={businessName} overrideOwnerId={overrideCompanyId} />
    </div>
  );
};

export default CompanyDirection;
